import { useEffect, useRef } from 'react';
import { drawTranscript, type SpeechPlace } from './transcript-graph';

/**
 * The recording, squeezed into a voice note that's read while its transcript is on its way. Only
 * to look at: the dictation's status says what's going on.
 */
export function TranscriptGraph({
  levels,
  length,
  from,
}: {
  readonly levels: readonly number[];
  /** How long the recording is, as the timer showed it. */
  readonly length: string;
  /** Where the speech graph was, so its bars carry on from there. */
  readonly from?: SpeechPlace | undefined;
}) {
  const canvasRef = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    return canvas ? drawTranscript(canvas, levels, { length, from }) : undefined;
  }, [levels, length, from]);

  return <canvas ref={canvasRef} className="transcript-graph" aria-hidden="true" />;
}
